import React from "react";
import styles from "./footer.module.css";

const nameStyle = {
  fontSize: 15,
  fontWeight: 500,
  textAlign: "center",
  paddingTop: 20,
  color: "#fff",
};

const centerText = {
  fontSize: 12,
  fontWeight: 400,
  textAlign: "center",
  color: "#fff",
};

function Footer() {
  return (
    <div
      className={styles.footerText}
      style={{ backgroundColor: "#000", paddingBottom: 20 }}
    >
      <div style={nameStyle}>Adi Gonsalves</div>
      <div style={centerText}>thedesignman.com</div>
      <div style={centerText}>
        Built with React Redux, Material UI and Chart JS
      </div>
      <div style={centerText}>Data provided by NovelCOVID API and Apify</div>
      <p style={centerText}>
        <a href="https://www.freepik.com/free-photos-vectors/infographic">
          Infographic vector created by pikisuperstar - www.freepik.com{" "}
        </a>
        <br></br>
        <a href="https://www.freepik.com/vectors/girl">
          Logo created by brgfx - www.freepik.com
        </a>
      </p>
    </div>
  );
}

export default Footer;
